import axios from "axios";

// Sessão por cookie HttpOnly: todos os pedidos enviam o cookie; o cabeçalho X-Requested-With é exigido pelo backend nos métodos de escrita (anti-CSRF)
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
